import { Spin } from 'antd';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import styles from './button.module.scss';
import { ButtonProps, ButtonVariant } from './types';

const buttonVariantsStyles: Record<ButtonVariant, string> = {
  text: styles.buttonText,
  tag: '',
  default: '',
  filled: '',
  danger: styles.buttonDanger,
  success: styles.buttonSuccess,
  primary: styles.buttonPrimary,
  secondary: styles.buttonSecondary,
  tertiary: styles.buttonTertiary,
};

export const Button = observer(function Button({
  as: Wrapper = 'button',
  target,
  width,
  className,
  children,
  type = 'button',
  variant = 'filled',
  prefixIcon,
  icon,
  iconPosition = 'after',
  disabled,
  href,
  onClick,
  loading = false,
}: ButtonProps) {
  return (
    <Wrapper
      className={clsx(
        className,
        styles.button,
        variant && buttonVariantsStyles[variant],
        iconPosition === 'before' && styles.buttonReversed
      )}
      type={Wrapper === 'button' ? type : undefined}
      disabled={disabled}
      style={{ width }}
      href={Wrapper === 'a' ? href : undefined}
      target={Wrapper === 'a' ? target : undefined}
      onClick={onClick}
    >
      {!!prefixIcon && (
        <div className={clsx(styles.buttonIconWrapper, styles.prefixIcon)}>
          {loading ? <Spin size="small" className={styles.buttonLoader} /> : prefixIcon}
        </div>
      )}

      {!!children && <div className={styles.buttonInner}>{children}</div>}

      {!!icon && (
        <div className={clsx(styles.buttonIconWrapper)}>
          {loading && !prefixIcon ? <Spin size="small" className={styles.buttonLoader} /> : icon}
        </div>
      )}
    </Wrapper>
  );
});
